import * as React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Spinner } from "components/common";
import {
  useFetchLookupTable,
  useFetchCache,
  useFetchDataAdapter
} from "components/lookup-tables/hooks/useLookupTablesAPI";
import { ErrorsProvider } from "components/lookup-tables/contexts/ErrorsContext";
import LookupTableShow from "./lookup-table-show";
function LookupTableView() {
  const { t } = useTranslation("lookup_tables");
  const { lutIdOrName } = useParams();
  const { lookupTable, loadingLookupTable } = useFetchLookupTable(lutIdOrName);
  const { cache, loadingCache } = useFetchCache(lookupTable == null ? void 0 : lookupTable.cache_id);
  const { dataAdapter, loadingDataAdapter } = useFetchDataAdapter(lookupTable == null ? void 0 : lookupTable.data_adapter_id);
  if (loadingLookupTable || loadingCache || loadingDataAdapter) return /* @__PURE__ */ React.createElement(Spinner, { text: t("lut_view.loading") });
  return /* @__PURE__ */ React.createElement(ErrorsProvider, null, /* @__PURE__ */ React.createElement(LookupTableShow, { table: lookupTable, cache, dataAdapter }));
}
export default LookupTableView;
